import { Button, Col, Modal, Row, message } from 'antd'
import { inject, observer } from 'mobx-react'
import React, { useCallback, useState } from 'react'
import { Config } from '../../utils/config'
import GetFreeNumberSuccess from './GetFreeNumberSuccess'

function FreeNumberExpiredModal(props) {
  const { userStore } = props
  const [loading, setLoading] = useState(false)
  const [showModal, setShowModal] = useState(true)
  const {
    isUserFreeType,
    isUserEmailVerified,
    userIsGotFreeNumber,
    isFreeNumberExpired,
    isUserHasNumber,
    phonesIsRequest,
  } = userStore

  const visible =
    showModal &&
    isUserFreeType && // 免费用户
    isUserEmailVerified && // 已验证邮箱
    userIsGotFreeNumber && // 已经获取过 免费号码
    phonesIsRequest && // 请求过服务器拿取号码列表
    (!isUserHasNumber || // 现在没有号码
      isFreeNumberExpired) // 免费号码已经过期
  const getFreeNumberClick = () => {
    setLoading(true)
    // 获取免费号码
    userStore
      .requestFreeNumber()
      .then(
        // 获取成功
        (freeNumber) => {
          console.log(freeNumber)
          if (!freeNumber) {
            message.error('Failed to get the fax number. Please retry.')
            return Promise.reject('Failed to get the fax number. Please retry.')
          }
          return new Promise((re) => {
            const m = Modal.confirm({
              width: 460,
              icon: null,
              content: (
                <GetFreeNumberSuccess
                  number={freeNumber}
                  onOkClick={() => {
                    m.destroy()
                    re()
                  }}
                />
              ),
              okButtonProps: { hidden: true },
              cancelButtonProps: { hidden: true },
            })
          })
        },
        // 获取失败
        (_) => {
          Modal.warn({
            content: 'Your application has been submitted. This may take some time. You may log in later and check.',
            okText: 'Confirm',
          })
          return Promise.reject()
        }
      )
      .then((_) => {
        // 获取成功 后 关闭弹窗
        setShowModal(false)
        // 更新用户数据
        userStore.requestUserInfo()
        userStore.requestUserPhones()
      })
      // 无论成功失败 loading false
      .finally(() => {
        setLoading(false)
      })
  }

  const pricingClick = useCallback(() => {
    window.location.href = Config.PRICING_URL
  }, [])

  return (
    <Modal width="450px" visible={visible} footer={null} closable={false} title="Fax Number Expired">
      <>
        <p>
          Your fax number has expired. You may choose to get a new temporary fax number, or
          <span className="font-bold"> get a PERMANENT fax number.</span>
        </p>
        <Row justify="space-between" style={{ marginTop: '28px' }}>
          <Col>
            <Button type="primary" ghost loading={loading} onClick={getFreeNumberClick}>
              Get a temporary one
            </Button>
          </Col>
          <Col>
            <Button type="primary" onClick={pricingClick}>
              Get a permanent number
            </Button>
          </Col>
        </Row>
      </>
    </Modal>
  )
}

export default inject('userStore')(observer(FreeNumberExpiredModal))
